export default "/public/dist/img/codiceAteco.png";